module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/h1-title@3x-14d6dd1c062dd265e847aa0c6f522188.png";